import { apiClient, APIResponse, extractApiError, buildQuery } from './api';


export function normalizeSnapshotList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export const snapshotsAPI = {
  async listSnapshots(params) {
    try {
      const { data } = await apiClient.get(`/snapshots/${buildQuery(params)}`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar as selfies mensais.'),
      );
    }
  },

  async currentSnapshot() {
    try {
      const { data } = await apiClient.get('/snapshots/current/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar a selfie actual.'),
      );
    }
  },

  async listCycles() {
    try {
      const { data } = await apiClient.get('/snapshots/cycles/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar os ciclos.'),
      );
    }
  },

  async patchCurrentCycle({ start, end }) {
    try {
      const body = { start };
      if (end !== undefined && end !== null) {
        body.end = end;
      }
      const { data } = await apiClient.patch('/snapshots/cycles/current/', body);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar o ciclo actual.'),
      );
    }
  },

  async createSnapshot(payload) {
    try {
      const { data } = await apiClient.post('/snapshots/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível registar a selfie.'),
      );
    }
  },

  async netWorthTimeline(params) {
    try {
      const { data } = await apiClient.get(
        `/net-worth/timeline/${buildQuery(params)}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar a evolução do Património.'),
      );
    }
  },

  // CHANGE v2 §11: GET de um único snapshot (para a página de edição).
  async getSnapshot(id) {
    try {
      const { data } = await apiClient.get(`/snapshots/${id}/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar a selfie.'),
      );
    }
  },

  // CHANGE v2 §11: PATCH a um snapshot mensal.
  async updateSnapshot(id, payload) {
    try {
      const { data } = await apiClient.patch(`/snapshots/${id}/`, payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar a selfie.'),
      );
    }
  },

  // CHANGE v2 §11: DELETE a um snapshot mensal.
  async deleteSnapshot(id) {
    try {
      await apiClient.delete(`/snapshots/${id}/`);
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível apagar a selfie.'),
      );
    }
  },

  // CHANGE v2 §11: PATCH a um child snapshot (linha por conta).
  async updateAccountSnapshot(id, payload) {
    try {
      const { data } = await apiClient.patch(`/account-snapshots/${id}/`, payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar o saldo.'),
      );
    }
  },

  // CHANGE v2 §14.6: lista os cofres com contribuições mensais por confirmar.
  async emergencyFundReview(snapshotId) {
    try {
      const { data } = await apiClient.get(
        `/snapshots/${snapshotId}/emergency-fund-review/`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível obter a revisão do fundo.'),
      );
    }
  },

  async getReport(snapshotId) {
    try {
      const { data } = await apiClient.get(`/snapshots/${snapshotId}/report/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o relatório.'),
      );
    }
  },

  async regenerateReport(snapshotId) {
    try {
      const { data } = await apiClient.post(
        `/snapshots/${snapshotId}/report/regenerate/`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível regenerar o relatório.'),
      );
    }
  },

  async monthlyChecks(snapshotId) {
    try {
      const { data } = await apiClient.get(
        `/snapshots/${snapshotId}/monthly-checks/`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível obter os cofres a confirmar.'),
      );
    }
  },
};
